import React from 'react';
import { pixelValueToNorm } from '../../Utils/PixelUtils';

class BrushsizePicker extends React.Component {

    constructor(props) {
        super(props);
        this.valueUpdated = this.props.valueUpdated;

        this.state = {
            selectedIndex: this.props.selectedIndex ?? 1,
            canvasWidth: this.props.canvasWidth
        }

        this.defaultNBrushsizes = 8;
        this.brushsizes = this.getBrushsizes();
        console.log(this.brushsizes);

        this.style = {
            circularDiv: {
                borderRadius: '50%',
                margin: '5px 5px',
                backgroundColor: '#000000',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            },
            selectionDiv: {
                flex: 1,
                cursor: 'pointer',
                minHeight: '50px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }
        }
    }

    getSelected(index) {
        if (index == this.state.selectedIndex) {
            return <div style={{
                borderRadius: '50%',
                width: `${this.brushsizes.get(index) - 2}px`,
                height: `${this.brushsizes.get(index) - 2}px`,
                backgroundColor: `#FFFFFF`
            }}></div>
        }
    }

    select(index) {
        this.setState({ selectedIndex: index });
        this.valueUpdated(pixelValueToNorm(this.brushsizes.get(index), this.state.canvasWidth), index);
    }

    getBrushsizes() {
        var nBrushsizes = this.props.nBrushsizes ?? this.defaultNBrushsizes;
        var incrementFactor = this.defaultNBrushsizes / nBrushsizes;
        var brushsizes = new Map();
        for (var i = 1; i <= nBrushsizes; i++) {
            var size = Math.floor(Math.pow(1.53, (i * incrementFactor) - 1) * 2);
            brushsizes.set(i - 1, size);
        }
        return brushsizes;
    }

    render() {
        this.state.selectedIndex = this.props.selectedIndex ?? 1;
        return (
            <div data-tip={this.props.dataTip} style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center'
            }}>
                {[...this.brushsizes.keys()].map((index) => (
                    <div key={index} style={this.style.selectionDiv} onClick={() => this.select(index)}>
                        <div style={{ ...this.style.circularDiv, width: `${this.brushsizes.get(index)}px`, height: `${this.brushsizes.get(index)}px` }}>
                            {this.getSelected(index)}
                        </div>
                    </div>
                ))}
            </div>
        );
    }
}

export default BrushsizePicker;